/* Aufguss Roots — ReviewsIO Output Cleanup
 *
 * Das ReviewsIO-Widget rendert Star-Snippets als "(9 Reviews)" oder
 * "(9 Bewertungen)". Wir wollen aber nur "(9)" anzeigen, damit es
 * konsistent mit dem theme-native review-Block ist.
 *
 * Strategie: nach jedem Render (initial + via MutationObserver) alle
 * .ruk_rating_snippet / .ruk-rating-snippet / [class*="reviewsio"]
 * scannen und in TextNodes "Bewertungen|Reviews|Bewertung|Review" rausstrippen.
 */
(function () {
  var WORD_RE = /\s*(Bewertungen?|Reviews?)\b/gi;

  function cleanTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    var current = node.nodeValue;
    var next = current.replace(WORD_RE, '');
    if (next !== current) {
      // Einzelne übrig-gebliebene Klammern oder Leerzeichen normalisieren:
      // "(9 )" → "(9)", "9 " → "9"
      next = next.replace(/\(\s*(\d[\d\s.,]*)\s*\)/g, '($1)');
      next = next.replace(/\s{2,}/g, ' ').replace(/\s+\)/g, ')').replace(/\(\s+/g, '(');
      node.nodeValue = next;
    }
  }

  function walkAndClean(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      cleanTextNode(node);
    }
  }

  function cleanAllRatingSnippets() {
    var selectors = [
      '.ruk_rating_snippet',
      '.ruk-rating-snippet',
      'reviewsio-product-ratings',
      '[class*="rating-snippet"]',
      '[class*="rating_snippet"]',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(walkAndClean);
  }

  function init() {
    cleanAllRatingSnippets();

    // ReviewsIO lädt async und re-rendert teilweise mehrfach.
    var observer = new MutationObserver(function (mutations) {
      var needsClean = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData' || m.addedNodes.length) {
          needsClean = true;
          break;
        }
      }
      if (needsClean) {
        cleanAllRatingSnippets();
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    // Safety-Net: nochmal nach 1s, 3s, 5s — falls async-Inits später kommen.
    [1000, 3000, 5000].forEach(function (delay) {
      setTimeout(cleanAllRatingSnippets, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
